import { Skeleton, SkeletonBlock } from '@one-thd/sui-atomic-components';
import React, { useEffect, useState } from 'react';
import { UNAVAILABLE_IMAGE_URL } from '../../constants/general';
export var CustomImage = function (_a) {
    var src = _a.src, _b = _a.alt, alt = _b === void 0 ? 'Unavailable image' : _b, lazy = _a.lazy, _c = _a.width, width = _c === void 0 ? 'auto' : _c, _d = _a.height, height = _d === void 0 ? 'auto' : _d;
    var _e = useState(src), imageSrc = _e[0], setImageSrc = _e[1];
    var _f = useState(false), imageLoaded = _f[0], setImageLoaded = _f[1];
    useEffect(function () {
        var img = new Image();
        img.src = imageSrc;
        img.onload = function () {
            setImageSrc(src);
            setImageLoaded(true);
        };
        img.onerror = function () {
            setImageSrc(UNAVAILABLE_IMAGE_URL);
            setImageLoaded(true);
        };
    }, [src]);
    return (React.createElement(React.Fragment, null, imageLoaded ? (React.createElement("img", { loading: lazy ? 'lazy' : undefined, src: imageSrc, alt: imageLoaded ? alt : '', width: width, height: height })) : (React.createElement(Skeleton, { disablePadding: true },
        React.createElement(SkeletonBlock, { width: 12, height: 12 })))));
};
